import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { FaFontWeight } from '../../icon';
import { MuiButtonAppearance } from './mui-button-appearance.type';
import { MuiButtonSize } from './mui-button-size.enum';


let nextUniqueId = 0;

@Component({ template: '' })
export abstract class MuiButtonBaseClass {
  abstract get buttonClassList(): string;

  @Input()
  @HostBinding('attr.id')
  id: string | null = `mui-btn-${nextUniqueId++}`;

  @Input()
  @HostBinding('attr.disabled')
  set disabled(disabled: boolean | null) {
    this._disabled = disabled;
  }

  get disabled(): boolean | null {
    return this._disabled || this.working || null;
  }

  @Input() appearance: MuiButtonAppearance = 'primary';

  @Input() icon: string | null = null;

  @Input() iconStyle: FaFontWeight = FaFontWeight.LIGHT;

  @Input() working: boolean | null = null;

  @Input() size?: MuiButtonSize | string;

  private _disabled: boolean | null = null;

  protected constructor(protected el: ElementRef) {
  }

  protected static isValidEnumValue = (
    en: Record<string, unknown>,
    val: any
  ): boolean => !!val && Object.values(en).includes(val);
}
